/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Provides the AdministrationApiConfiguration configuration object with a given root URL.
 */
export function provideAdministrationApiConfiguration(rootUrl: string) {
  var config = new AdministrationApiConfiguration();
  config.rootUrl = rootUrl;
  return {
    provide: AdministrationApiConfiguration,
    useValue: config
  };
}

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class AdministrationApiConfiguration {
  rootUrl: string = '/';
}

